import React, {useContext} from 'react'
import { GlobalContext } from "../contexts/GlobalContext";

const EditModeToggle = () => {
    const {editing,setEditing} = useContext(GlobalContext);
  return (
    <button onClick={(e) => {
        e.preventDefault();
        setEditing(!editing);
    }} className="flex flex-row space-x-[1px] rounded-full overflow-hidden p-[1px] bg-white">
        <div className={`w-4 h-4 rounded-full shrink-0 ${!editing && 'bg-gray'}`}></div>
        <div className={`w-4 h-4 rounded-full shrink-0 ${editing && 'bg-theme'}`}></div>
    </button>
  )
}

export default EditModeToggle